import { queryOptions, useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';

import { FIVE_MINUTES } from '@/constants/time';
import { userIdAtom } from '@/services/globalState';
import { paths } from '@/types/api';
import { fetchClient } from '@/util/fetchClient';

export type InquiryStatsResponse =
  paths['/v2/inquiries/stats']['get']['responses'][200]['content']['application/json']['data'];

async function getInquiryStats() {
  const { data } = await fetchClient.GET('/v2/inquiries/stats', {
    params: {},
  });

  return data?.data;
}

export const getInquiryStatsQueryOptions = (userId: string | undefined) =>
  queryOptions({
    queryKey: ['inquiryStats', userId],
    queryFn: getInquiryStats,
    staleTime: 60_000,
    gcTime: FIVE_MINUTES,
    refetchOnWindowFocus: false,
  });

export function useInquiryStats() {
  const userId = useAtomValue(userIdAtom);

  return useQuery(getInquiryStatsQueryOptions(userId));
}
